import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { ThemeContext } from '../../context/ThemeContext'
import { AiOutlineArrowLeft, AiOutlineCompass } from 'react-icons/ai'

const PageNotFound = () => {
    const { primaryColor } = useContext(ThemeContext)
    const navigate = useNavigate()

    return (
        <div className="min-h-screen bg-[#faf8f4] flex flex-col items-center justify-center p-6 text-center text-slate-800">
            <div className="mb-8 flex h-28 w-28 items-center justify-center rounded-[2rem] bg-white shadow-[0_12px_28px_rgba(0,0,0,0.06)] ring-1 ring-slate-100">
                <AiOutlineCompass className="text-6xl" style={{ color: primaryColor || '#a34b3f' }} />
            </div>
            
            <h1 className="text-[80px] font-extrabold leading-none tracking-tight" style={{ color: primaryColor || '#a34b3f' }}>404</h1>
            <h2 className="mt-2 text-xl font-bold text-slate-800">Halaman Tidak Ditemukan</h2>
            <p className="mt-3 text-sm leading-relaxed text-slate-500 max-w-[280px]">
                Maaf, halaman yang Anda cari mungkin telah dihapus, diubah namanya, atau tidak tersedia untuk saat ini.
            </p>
            
            <button
onClick={() => navigate('/product', { replace: true })}
                className="mt-10 flex w-full max-w-[220px] items-center justify-center gap-2 rounded-xl px-6 py-4 text-sm font-semibold text-white transition-all active:scale-95"
                style={{ 
                    backgroundColor: primaryColor || '#a34b3f', 
                    boxShadow: `0 10px 25px ${primaryColor ? primaryColor + '40' : 'rgba(163, 75, 63, 0.3)'}` 
                }}
            >
                <AiOutlineArrowLeft className="text-lg" />
                Kembali ke Beranda
            </button>
        </div>
    )
}

export default PageNotFound
